import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5aecb82c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = {
  key: 0,
  class: "color-price-box"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "style-font-size" }, "未选中", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "style-font-size" }, "选中", -1))
const _hoisted_5 = { class: "sort-menu-list-box" }
const _hoisted_6 = { class: "card-head-box" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "display-style-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-style-box" }, "标题:", -1))
const _hoisted_10 = { class: "display-style-box" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-style-box" }, "图片:", -1))
const _hoisted_12 = { class: "menu-icon-content-box" }
const _hoisted_13 = { class: "menu-item-box" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "默认", -1))
const _hoisted_15 = { class: "menu-item-box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "选中(可选)", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-image-remake" }, " 图片尺寸要求：不大于128*100像素，支持PNG格式 ", -1))
const _hoisted_18 = { class: "edit-link-box" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "edit-link-left-box" }, "页面:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_ui_layout2 = _resolveComponent("ui-layout2")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_ui_icon_zhizhi = _resolveComponent("ui-icon-zhizhi")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ui_choose_icon = _resolveComponent("ui-choose-icon")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_ui_select_link = _resolveComponent("ui-select-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_layout2, {
      title: "背景颜色",
      ext: _ctx.modelValue.style.backgroundColor
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "text",
          style: {"margin":"0 10px 0 0"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
        _ctx.modelValue.style.backgroundColor = _ctx.defaultData.data.style.backgroundColor
        ))
        }, {
          default: _withCtx(() => [
            _createTextVNode("重置")
          ]),
          _: 1
        }),
        _createVNode(_component_el_color_picker, {
          modelValue: _ctx.modelValue.style.backgroundColor,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValue.style.backgroundColor) = $event)),
          onActiveChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue.style.backgroundColor = $event)),
          "show-alpha": ""
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["ext"]),
    _createVNode(_component_ui_layout2, { title: "导航颜色" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_radio_group, {
          modelValue: _ctx.modelValue.colorType,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modelValue.colorType) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "0" }, {
              default: _withCtx(() => [
                _createTextVNode("自定义")
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "1" }, {
              default: _withCtx(() => [
                _createTextVNode("全局模式")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (_ctx.modelValue.colorType == '0')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_color_picker, {
                modelValue: _ctx.modelValue.color,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelValue.color) = $event)),
                onActiveChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.color = $event)),
                "show-alpha": ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "text",
                style: {"margin":"0 0 0 10px"},
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue.color = _ctx.defaultData.data.color))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              })
            ]),
            _hoisted_3
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_color_picker, {
                modelValue: _ctx.modelValue.color1,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelValue.color1) = $event)),
                onActiveChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.modelValue.color1 = $event)),
                "show-alpha": ""
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "text",
                style: {"margin":"0 0 0 10px"},
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.modelValue.color1 = _ctx.defaultData.data.color1))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              })
            ]),
            _hoisted_4
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_draggable, {
        modelValue: _ctx.modelValue.list,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modelValue.list) = $event)),
        handle: ".card-head-box"
      }, {
        item: _withCtx(({ element, index }) => [
          (_openBlock(), _createBlock(_component_el_card, {
            class: "menu-card-box",
            key: index
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_ui_icon_zhizhi, { modelValue: "iconsort" })
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "close-right-button",
                onClick: _withModifiers(($event: any) => (_ctx.removeIndex(index)), ["stop"])
              }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Close)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_el_input, {
                  placeholder: "可留空",
                  modelValue: element.text,
                  "onUpdate:modelValue": ($event: any) => ((element.text) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_ui_choose_icon, {
                        modelValue: element.icon,
                        "onUpdate:modelValue": ($event: any) => ((element.icon) = $event),
                        showClose: false,
                        tips: "更换图片",
                        style: _normalizeStyle(_ctx.iconColor1)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "style"]),
                      _hoisted_14
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_ui_choose_icon, {
                        modelValue: element.icon2,
                        "onUpdate:modelValue": ($event: any) => ((element.icon2) = $event),
                        tips: "更换图片",
                        style: _normalizeStyle(_ctx.iconColor2)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "style"]),
                      _hoisted_16
                    ])
                  ]),
                  _hoisted_17
                ])
              ]),
              _createVNode(_component_el_divider),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_ui_select_link, {
                  type: "menu",
                  modelValue: element.link,
                  "onUpdate:modelValue": ($event: any) => ((element.link) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ])
            ]),
            _: 2
          }, 1024))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.modelValue.list.length < 5)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "button-width-box",
            onClick: _ctx.addMenu,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("+ 添加导航")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}